import React, { useMemo } from 'react';
import calendarAddIconSrc from 'assets/icons/new/color/calendar-add.svg';
import calendarCheckIconSrc from 'assets/icons/new/color/calendar-check.svg';
import calendarPlusIconSrc from 'assets/icons/new/color/calendar-plus.svg';
import checklistWriteIconSrc from 'assets/icons/new/color/checklist-write.svg';
import checklistWriteBlueIconSrc from 'assets/icons/new/color/checklist-write-blue.svg';
import checkWriteIconSrc from 'assets/icons/new/color/check-write.svg';
import downloadIconSrc from 'assets/icons/new/color/download.svg';
import linkedinIconSrc from 'assets/icons/new/color/linkedin.svg';
import userTimesIconSrc from 'assets/icons/new/color/user-times.svg';
import usersTimesIconSrc from 'assets/icons/new/color/users-times.svg';
import userPlusIconSrc from 'assets/icons/new/color/user-plus.svg';
import textSignIconSrc from 'assets/icons/new/color/text-sign.svg';
import textWriteIconSrc from 'assets/icons/new/color/text-write.svg';

type IconName =
	| 'calendar-add'
	| 'calendar-check'
	| 'calendar-plus'
	| 'checklist-write'
	| 'checklist-write-blue'
	| 'check-write'
	| 'download'
	| 'linkedin'
	| 'user-times'
	| 'users-times'
	| 'user-plus'
	| 'text-sign'
	| 'text-write';

type IconColorProps = {
	name: IconName;
	className?: string;
};

export const IconColor = ({ name, className }: IconColorProps) => {
	const { src, alt } = useMemo(() => {
		switch (name) {
			case 'calendar-add':
				return {
					src: calendarAddIconSrc,
					alt: 'Calendar add icon',
				};
			case 'calendar-check':
				return {
					src: calendarCheckIconSrc,
					alt: 'Calendar check icon',
				};
			case 'calendar-plus':
				return {
					src: calendarPlusIconSrc,
					alt: 'Calendar plus icon',
				};
			case 'checklist-write':
				return {
					src: checklistWriteIconSrc,
					alt: 'Checklist write icon',
				};
			case 'checklist-write-blue':
				return {
					src: checklistWriteBlueIconSrc,
					alt: 'Checklist write icon',
				};
			case 'check-write':
				return {
					src: checkWriteIconSrc,
					alt: 'Check write icon',
				};
			case 'user-times':
				return {
					src: userTimesIconSrc,
					alt: 'User times icon',
				};
			case 'users-times':
				return {
					src: usersTimesIconSrc,
					alt: 'Users times icon',
				};
			case 'user-plus':
				return {
					src: userPlusIconSrc,
					alt: 'Users plus icon',
				};
			case 'download':
				return {
					src: downloadIconSrc,
					alt: 'Download icon',
				};
			case 'linkedin':
				return {
					src: linkedinIconSrc,
					alt: 'LinkedIn icon',
				};
			case 'text-sign':
				return {
					src: textSignIconSrc,
					alt: 'Text sign icon',
				};
			case 'text-write':
				return {
					src: textWriteIconSrc,
					alt: 'Text write icon',
				};
			default:
				return {
					src: '',
					alt: '',
				};
		}
	}, [name]);

	return <img src={src} alt={alt} className={className} />;
};
